import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const QuickActions = ({ onAction }) => {
  const quickActions = [
    {
      id: 'addContact',
      label: 'Add New Contact',
      description: 'Manually add a new media contact',
      icon: 'UserPlus',
      color: 'text-primary',
      bgColor: 'bg-primary/10'
    },
    {
      id: 'createCampaign',
      label: 'Create Campaign',
      description: 'Start a new email campaign',
      icon: 'Mail',
      color: 'text-success',
      bgColor: 'bg-success/10'
    },
    {
      id: 'buildList',
      label: 'Build Media List',
      description: 'Create targeted media lists',
      icon: 'List',
      color: 'text-warning',
      bgColor: 'bg-warning/10'
    },
    {
      id: 'viewAnalytics',
      label: 'View Analytics',
      description: 'Check engagement metrics',
      icon: 'BarChart3',
      color: 'text-accent',
      bgColor: 'bg-accent/10'
    }
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-6 mb-6">
      <h3 className="text-lg font-semibold text-foreground mb-4">Quick Actions</h3>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {quickActions?.map((action) => (
          <Button
            key={action?.id}
            variant="ghost"
            onClick={() => onAction(action?.id)}
            className="h-auto p-4 flex flex-col items-start text-left space-y-2 hover:bg-muted/50"
          >
            <div className={`p-2 rounded-md ${action?.bgColor}`}>
              <Icon name={action?.icon} size={20} className={action?.color} />
            </div>
            <div>
              <div className="font-medium text-foreground text-sm">
                {action?.label}
              </div>
              <div className="text-xs text-muted-foreground">
                {action?.description}
              </div>
            </div>
          </Button>
        ))}
      </div>
    </div>
  );
};

export default QuickActions;